
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { Document } from "../../../domain/document";
import { SystemLogger } from "../../../domain/system";
import { default as DocumentsProcessViewMixin } from "./DocumentsProcessViewMixin.vue";

@Component
export default class DocumentsPrintViewMixin extends Mixins(DocumentsProcessViewMixin) {
  @Prop()
  printerName: string;

  @Prop()
  shouldPrintDefaultCopies: boolean;

  @Prop()
  printCopies: number;

  async printDocuments(ids: number[], intervalMilliSeconds: number): Promise<number> {
    if (!ids) {
      throw new Error("文書IDが指定されていません.指定してください.");
    }
    let count = 0;
    let isFirst = true;
    for (const id of ids) {
      if (!isFirst && intervalMilliSeconds > 0) {
        await this.$sleep(intervalMilliSeconds);
      }
      try {
        await this.printDocument(id);
        count++;
      } catch (e) {
        this.$logger.error(e.message);
        this.$logger.error("文書(文書ID:" + id + ")の印刷中に問題が発生しました.当該文書の処理をスキップします.");
        await SystemLogger.error("文書(文書ID:" + id + ")の印刷中に問題が発生しました.", e, this.patientNo);
      }
      isFirst = false;
    }
    return count;
  }

  async printDocument(id: number, withCommitAction: boolean = false): Promise<void> {
    this.$logger.info("文書(文書ID:" + id + ")を印刷します.(出力先プリンタ:" + this.printerName + ")");
    const repository = DomainRegistry.document.getDocumentRepository();
    const reference = await repository.getDocumentSummary(this.patientNo, id);
    const copies = this.shouldPrintDefaultCopies
      ? reference.defaultCopies
      : ((this.printCopies && isFinite(this.printCopies)) ? this.printCopies : 1);
    reference.printSource.withCommitAction = withCommitAction;
    if (this.printerName && (this.printerName !== "")) {
      this.$printPdfTo(reference.printSource.source, this.printerName, copies);
    } else {
      this.$printPdf(reference.printSource.source, copies);
    }
    this.$logger.info("文書(文書ID:" + id + ")を印刷しました.(出力先プリンタ:" + this.printerName + ")");
  }

  shouldPrintDocumentExchangePaper(document: Document, isFirstNormalRegister: boolean): boolean {
    return (document.attributes.behavior.shouldPrintSpecifiedSectionAtFirstRegistration && isFirstNormalRegister)
      && document.sections.some(s => s.shouldPrintOnFirstRegistered);
  }

  async printDocumentExchangePaper(patientCode: string, documentId: number): Promise<void> {
    this.$logger.info("引換証(文書ID:" + documentId + ")を印刷します.(出力先プリンタ:" + this.printerName + ")");
    const repository = DomainRegistry.document.getDocumentRepository();
    const reference = await repository.getDocumentSummary(patientCode, documentId);
    const printSource = repository.createDocumentExchangePaperPrintSource(patientCode, documentId, reference.edition);
    if (this.printerName && (this.printerName !== "")) {
      this.$printPdfTo(printSource.source, this.printerName);
    } else {
      this.$printPdf(printSource.source);
    }
    this.$logger.info("引換証(文書ID:" + documentId + ")を印刷しました.(出力先プリンタ:" + this.printerName + ")");
  }
}
